// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"showcase-module--wrapper--111kx","card":"showcase-module--card--1RSi9"};